// extracted by mini-css-extract-plugin
export var active = "_h2-7";
export var blink = "_h2-8";
export var dropDownSelector = "_h2-4";
export var dropDownWrapper = "_h2-3";
export var fakeCursor = "_h2-6";
export var fontSizeButton = "_h2-9";
export var formQuillEditor = "_h2-0";
export var pressed = "_h2-a";
export var qlBlank = "_h2-1";
export var textFormattingToolbar = "_h2-2";
export var textToolbarOption = "_h2-5";